// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  themeColor: '',
  production: false,
  url: 'aHR0cHM6Ly9wZS5jYW1zb25saW5lLmNvbS9hcGkvdjEvcGVmdW5k', //Live // 
  // url: 'https://edge360uat.camsonline.com/pe_api/v1/pefund' //uat
  // url: 'https://pestage.camsonline.com/pe_api/v1/pefund',// yuvaraj 
  // urlDP: "http://192.168.8.230/avendus_api/v1/process" //qat
  // urlDP: "https://pe.camsonline.com/avendus_api/v1/process" //uat
  // urlDP: "https://pe.camsonline.com/api_dp/v1/process"// LiveDP
  urlDP: "aHR0cHM6Ly9wZS5jYW1zb25saW5lLmNvbS9hcGlfZHAvdjEvcHJvY2Vzcw==",  //live // 
  foiloapi: "aHR0cHM6Ly9laXNjci5jYW1zb25saW5lLmNvbS9BY2N0U3RtdC9BY2N0U3RtdC5hc3B4"  //live 
  // urlDP: "https://wealthservuat.camsonline.com/avendus_api/v1/process" //uat
  // url:'https://apistaging.camsonline.com/peapi/v1/pefund' // staging

};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
